import {
  Box,
  Container,
  Divider,
  Heading,
  Link,
  Stack,
  Text,
  VStack
} from '@chakra-ui/react'
import LandingLayout from '../../layouts/landing'

const SECTION_COLOR = '#004876'

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Box>
    <Heading as="h2" size="md" color={SECTION_COLOR} mb={3}>
      {title}
    </Heading>
    {children}
    <Divider my={4} borderColor="gray.200" />
  </Box>
)

const PrivacyPolicy = () => {
  return (
    <LandingLayout>
      <Container maxW="container.lg" py={10}>
        <VStack spacing={6} align="stretch">
          <Heading as="h1" size="xl" color={SECTION_COLOR}>
            Política de Privacidad
          </Heading>

          <Text fontSize="md" color="gray.700">
            En EDUprivada nos tomamos muy en serio la privacidad de nuestros usuarios. Por eso, te contamos de forma clara y sencilla qué datos recopilamos, cómo los usamos y cómo los protegemos.
          </Text>

          <Section title="1. ¿Qué datos recopilamos?">
            <Text mb={3}>
              Cuando usás nuestro sitio, podemos recopilar:
            </Text>
            <Stack pl={4} spacing={1}>
              <Text>• Datos personales que proporcionás al registrarte (nombre, apellido, DNI y correo electrónico)</Text>
              <Text>• Información básica de tu perfil si te registrás con una cuenta de terceros (ej. Facebook o Google)</Text>
              <Text>• Información personalizada que completás en tu perfil.</Text>
            </Stack>
          </Section>

          <Section title="2. ¿Para qué usamos tus datos?">
            <Text mb={3}>Utilizamos tus datos solo para:</Text>
            <Stack pl={4} spacing={1}>
              <Text>• Crear y gestionar tu cuenta en eduprivada.ar</Text>
              <Text>• Ofrecerte una experiencia personalizada</Text>
              <Text>• Enviarte información relevante (si la autorizás)</Text>
            </Stack>
            <Text mt={4}>Nunca vendemos ni compartimos tus datos sin tu consentimiento.</Text>
          </Section>

          <Section title="3. ¿Cómo protegemos tu información?">
            <Text>
              Adoptamos medidas de seguridad técnicas y organizativas para proteger tu información contra accesos no autorizados, pérdidas o usos indebidos.
            </Text>
          </Section>

          <Section title="4. Tus derechos">
            <Text mb={3}>Como usuario/a, tenés derecho a:</Text>
            <Stack pl={4} spacing={1}>
              <Text>• Acceder a tus datos personales</Text>
              <Text>• Modificar o actualizar tu información</Text>
              <Text>• Solicitar la eliminación de tu cuenta y datos</Text>
            </Stack>
            <Text mt={3}>
              Podés ejercer estos derechos escribiéndonos a:{' '}
              <Link href="mailto:soporte-eduprivada@aiepa.org.ar" color="blue.600" fontWeight="bold">
                soporte-eduprivada@aiepa.org.ar
              </Link>
            </Text>
          </Section>

          <Section title="5. Uso de servicios de terceros">
            <Text>
              En algunos casos, usamos servicios de terceros (como Facebook Login) que también pueden recopilar datos. Estos servicios tienen sus propias políticas de privacidad.
            </Text>
          </Section>

          <Section title="6. Cambios en esta política">
            <Text>
              Podemos actualizar esta política en el futuro. Si hacemos cambios importantes, te los vamos a informar claramente en el sitio.
            </Text>
          </Section>

          <Section title="7. Eliminación de datos personales">
            <Text>
              Si querés eliminar tu cuenta y todos tus datos personales, escribinos a{' '}
              <Link href="mailto:soporte-eduprivada@aiepa.org.ar" color="blue.600" fontWeight="bold">
                soporte-eduprivada@aiepa.org.ar
              </Link>{' '}
              con el asunto: <Text as="em" display="inline">{'"Eliminar mi cuenta"'}</Text>. Vamos a responder en un plazo razonable y eliminar tu información según la ley.
            </Text>
          </Section>
          <Box pt={12} />
        </VStack>
      </Container>
    </LandingLayout>
  )
}

export default PrivacyPolicy

